import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import {
  FaBriefcase,
  FaUsers,
  FaExchangeAlt,
  FaMoneyBillWave,
} from 'react-icons/fa';
import "./TransactionStats.css";
const stats = [
  {
    icon: <FaBriefcase size={32} color="white" />,
    value: 21000,
    label: 'MERCHANTS',
    subText: 'Active business partners',
    bg: 'linear-gradient(135deg, #0047ab, #00b14f)',
  },
  {
    icon: <FaUsers size={32} color="white" />,
    value: 50,
    label: 'CLIENTS',
    subText: 'Enterprise partnerships',
    bg: 'linear-gradient(135deg,rgb(151, 237, 12), rgb(6, 122, 211))',
  },
  {
    icon: <FaExchangeAlt size={32} color="white" />,
    value: 1000000,
    label: 'TRANSACTIONS',
    subText: 'Processed by clients every month',
    bg: 'linear-gradient(135deg,rgb(242, 100, 181),rgb(72, 128, 233))',
  },
  {
    icon: <FaMoneyBillWave size={32} color="white" />,
    value: 300,
    label: 'TOTAL AMOUNT',
    subText: 'Processed per month',
    suffix: ' Cr.',
    bg: 'linear-gradient(135deg,rgb(23, 233, 208),rgb(21, 119, 135))',
  },
];

// Framer Motion Variants
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const cardVariants = {
  hidden: { opacity: 0, y: 50, scale: 0.9 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.6, ease: 'easeOut' },
  },
};

const TransactionStats = () => {
  const [counts, setCounts] = useState(stats.map(() => 0));
  const containerRef = useRef(null);
  const animated = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !animated.current) {
          animated.current = true;

          stats.forEach((stat, i) => {
            let start = 0;
            const increment = stat.value / 100;
            const animate = () => {
              start += increment;
              if (start < stat.value) {
                setCounts((prev) => {
                  const updated = [...prev];
                  updated[i] = Math.floor(start);
                  return updated;
                });
                requestAnimationFrame(animate);
              } else {
                setCounts((prev) => {
                  const updated = [...prev];
                  updated[i] = stat.value;
                  return updated;
                });
              }
            };
            requestAnimationFrame(animate);
          });
        }
      },
      { threshold: 0.3 }
    );

    if (containerRef.current) observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <motion.section
     className="py-5 transaction-stats-section"
      style={{ background: "#082510" }}
      ref={containerRef}
      variants={containerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: false, amount: 0.3 }}
    >
      <div className="container text-center " style={{ marginTop: '40px', marginBottom: '40px' }}>
        <p
          className="fw-semibold mb-1"
          style={{ color: '#facc15', fontSize: '18px' }}
        >
          Platform Performance
        </p>
        <h2
            className="fw-bold mb-3 stats-heading"
          style={{
            background: 'linear-gradient(180deg, #FFFF00,rgb(72, 245, 28))',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            fontSize: '40px',
          }}
        >
          Our Impact in Numbers
        </h2>

        <p className="text-white-50 mb-5 stats-subheading" style={{fontSize:"18px"}}>
          Empowering businesses with reliable payment processing solutions
        </p>

        <div className="row g-4 justify-content-center">
          {stats.map((stat, i) => (
            <motion.div
            className="col-lg-3 col-md-3 col-sm-6 col-12 col-md-3 stats-column"
              key={i}
              variants={cardVariants}
              whileHover={{
                scale: 1.05,
                
              }}
            >
              <div
                className="d-flex flex-column justify-content-center align-items-center p-4 text-white stats-card"
                style={{
                  background: stat.bg,
                  borderRadius: '20px',
                  borderTop: '5px solid yellow',
                  minHeight: '300px',
                  textAlign: 'center',
                }}
              >
                <div
                  style={{
                    background: 'rgba(255,255,255,0.1)',
                    width: 60,
                    height: 60,
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '20px',
                    marginTop: '10px',
                  }}
                >
                  {stat.icon}
                </div>
                <h3 className="fw-bold mb-2">
                  {counts[i].toLocaleString()}
                  {stat.suffix ? stat.suffix : '+'}
                </h3>
                <div className="text-uppercase fw-bold mb-1">
                  {stat.label}
                </div>
                <div className="small">{stat.subText}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
      <style>

      </style>
    </motion.section>
    
  );
};

export default TransactionStats;
